import { useQuery } from '@tanstack/react-query'
import { transactionSettingsKeys } from '../keys'
import { transactionSettingsService } from '../services'
import type { TransactionType } from '../../types'

export const useQueryDepositStatus = () => {
	return useQuery({
		queryKey: transactionSettingsKeys.depositStatus(),
		queryFn: () => transactionSettingsService.getDepositStatus(),
	})
}

export const useQueryWithdrawStatus = () => {
	return useQuery({
		queryKey: transactionSettingsKeys.withdrawStatus(),
		queryFn: () => transactionSettingsService.getWithdrawStatus(),
	})
}

export const useQueryStatus = (type: TransactionType) => {
	return useQuery({
		queryKey: transactionSettingsKeys.status(type),
		queryFn: () => transactionSettingsService.getStatus(type),
	})
}
